import React from "react";
import "../../../css/AreaGobierno/organigrama.css";

const Organigrama = () => (
  <div className="organigrama-bg">
    <div className="organigrama-container">
      <h2 className="text-center" style={{ color: "#137158", fontWeight: "bold", marginBottom: "2rem" }}>
        ORGANIGRAMA
      </h2>
      <h4 className="text-center mb-4" style={{ color: "#333" }}>
        Conocé cada una de las áreas que conforman el Gobierno de la Ciudad de Oliva.
      </h4>
      <div className="organigrama text-center" style={{ width: "60%", margin: "auto" }}>
        <a
          href={require("../../img/organigrama.jpg")}
          target="_blank"
          rel="noopener noreferrer"
          title="Organigrama"
          className="fancybox"
        >
          <img
            src={require("../../img/organigrama.jpg")}
            alt="Organigrama Municipal"
            className="img-fluid"
            style={{
              borderRadius: "12px",
              boxShadow: "0 2px 12px rgba(44,62,80,0.10)",
              maxWidth: "100%",
              marginBottom: "1.5rem"
            }}
          />
        </a>
      </div>
    </div>
  </div>
);

export default Organigrama;